<template>
  <LayoutContainer :props="props">
    <kaer-image
      :src="props.src"
      :url="props.url"
      :componentId="componentId"
      :clickTrackId="clickTrackId"
    />
  </LayoutContainer>
</template>

<script>
import KaerImage from '../image/index.vue';

export default {
  name: 'kaer-image-single',
  components: { KaerImage },
  props: {
    componentId: String,
    props: {
      type: Object,
      default: () => ({
        url: '',
        src: ''
      })
    }
  },
  data() {
    return {
      trackId: this.$teleCodes['image-single'],
      clickTrackId: this.$teleCodes['image-single-click']
    };
  },
  mounted() {
    this.uploadData(this.trackId, 'event', { url: this.props.url, src: this.props.src, kaerComponentId: this.componentId });
  }
};
</script>
